module.exports = __webpack_public_path__ + "static/media/video-perisur.0387706c.mp4";